//Generated File 
export const Approve = `Approve`;
export const EscalateToSpecificEmployee = `EscalateToSpecificEmployee`;
export const EscalateToSupervisor = `EscalateToSupervisor`;
export const Reject = `Reject`;
export const Return = `Return`;
export const ReturnToPreviousStep = `ReturnToPreviousStep`;
